module.exports = __webpack_public_path__ + "img/kuwait-2.538371b1.jpg";